// extracted by mini-css-extract-plugin
module.exports = {"dp3-crowdfunding-bundle":"NA2_dp3-crowdfunding-bundle__LRsEP","tooltips":"NA2_tooltips__0jjOJ"};